
import Vue from "vue";
import ToolsLeft from "@/components/ToolsLeft.vue";
import axios from 'axios';
import Swiper, {
  Autoplay,
  EffectCoverflow,
  EffectCube,
  Pagination,
  Navigation,
} from "swiper";
Swiper.use([Autoplay, EffectCoverflow, EffectCube, Pagination, Navigation]);
import "swiper/swiper-bundle.css";
import API from "../service/config";
import { post, fetch, patch, put, toDelete } from "../service/http-service";
export default Vue.extend({
  name: "Tools",
  components: {
    ToolsLeft,
  },
  data() {
    return {
      jobId: "",
      jobIdArr: [{ jid: "" }],
      reportSrc: "",
      jobData: "",
      keyName: "job_id",
      submit: "",
      scaleFactor: 1,
      keyword: "",
      animate: false,
      tips: "null",
      Image1: "", //@/assets/images/test.jpg
      Image2: "",
      Image3: "",
      downUrl: '',
      timer: null as any,
    };
  },
    created() {
    // 在组件创建时启动定时器
    this.startTimer();
  },
  mounted() {
      this.initCookie();
      this.initSwiper();
    
  },
  beforeDestroy() {
    // 在组件销毁前停止定时器
    this.stopTimer();
  },
  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        if(this.keyword!=null && this.keyword!=""){
          this.handleCommand(this.keyword);
        }
        
      },10000)
    },
    stopTimer() {
      // 停止定时器
      clearInterval(this.timer);
    },
    initCookie() {
      //let name = VueCookies.get(this.keyName);
      //let name = this.$cookies.get(this.keyName);
      let name = localStorage.getItem(this.keyName);
      if (name != null) {
        //首次加载截取页面
        let arrbyId: any = [];
        arrbyId = name.split(",");
        this.jobIdArr = [{ jid: "" }];
        for (let i = 0; i < arrbyId.length; i++) {
          this.jobIdArr.push({
            jid: arrbyId[i],
          });
        }
        this.jobId = this.jobIdArr[this.jobIdArr.length - 1].jid;
      }
      let curPath = window.document.location.href;
      let hav_jobid = curPath.indexOf("job_id=");
      if (hav_jobid != -1) {
        this.jobId = curPath.substring(hav_jobid + 7);
      }

      this.$nextTick(() => {
      if (this.jobId != null) {
        this.handleCommand(this.jobId);
      }
      setTimeout(() => {
        this.initSwiper();
      }, 2000);
      });
    },
    handleCommand(command: string) {
      this.keyword = command;
      fetch(API.domainUrl + API.getJob + "?jobId=" + command).then(
        (response: any) => {
          if (response.status.code == 200) {
            this.jobId = command;
            this.jobData = response.data;
            const path = response.data.result;
            const resultPath = path.substring(path.lastIndexOf('/') + 1);
            const url = 'http://liwzlab.ifr.fidt.top:61010/sc_result/';
            this.Image1 = url+resultPath+"/original_UMAP.png";
            this.Image2 = url+resultPath+"/TRS_bar.png";
            this.Image3 = url+resultPath+"/TRS_UMAP.png";
            this.downUrl = url+resultPath+'/result.tar.gz';
          } else {
            this.$message.error(response.status.msg);
          }
        }
      );
      setTimeout(() => {
        this.initSwiper();
      }, 2000);
    },
    initSwiper() {
      new Swiper(".swiper-container", {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        loop: true,
      });
    },
    message(msg: number) {
      if (msg == 4) {
        this.$notify({
          title: (this.$t('datacenter')) as string,
          message: (this.$t('dataerror')) as string,
        });
      }else if (msg == 3){
      const link = document.createElement('a');
      link.download = 'result.tar.gz'; // 设置下载的文件名
      axios.get(this.downUrl, { responseType: 'blob' })
        .then((response) => {
        const blob = new Blob([response.data]);
        link.href = URL.createObjectURL(blob)
        console.log(link.href)
        //link.download = ''
        document.body.appendChild(link)
        link.click()
        })
        .catch((error) => {
          console.error((this.$t('downerror')) as string, error);
        });
      }
    },
  },
});
